import { useCreateRealEstateAgencyMutation } from '../../api';
import { useGetAccessToken } from '../auth/get-access-token.hook';

const useCreateRealEstateAgency = (options: any) => {
  const { headerWithAuth } = useGetAccessToken();
  const { mutate } = useCreateRealEstateAgencyMutation(headerWithAuth, options);

  return mutate;
};

export {
  useCreateRealEstateAgency,
};
